import { Button } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { useTranslation } from 'react-i18next';
import { PiNavigationArrow, PiTrash } from 'react-icons/pi';
import { IExternalId } from 'services/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import './ExternalIdCard.scss';

interface IExternalIdCardProps {
  externalId: IExternalId;
  index: number;
  displayMode?: boolean;
  onRemove?: () => void;
}

const ExternalIdCard = ({ externalId, index, displayMode, onRemove }: IExternalIdCardProps) => {
  const { t } = useTranslation();
  return (
    <div className="external-id-card">
      {displayMode ? (
        <div className="external-id-name">
          <div className="external-id-header">{externalId.type}</div>
          <div className="external-id-footer">{externalId.id}</div>
        </div>
      ) : (
        <div className="external-id-inputs">
          <FormInput.Select
            name={`externalIds[${index}].type`}
            label={t(`input.label.externalIdType`)}
            options={[]}
            appBackground
            isCreatable
          />
          <FormInput.Text name={`externalIds[${index}].id`} label={'ID'} appBackground />
        </div>
      )}
      {displayMode ? (
        !!externalId.link?.length && (
          <Button
            isClear
            onlyIcon
            className="flip-icon-x"
            onClick={() => window.open(externalId.link ?? '', '_blank')}
          >
            <Button.Icon icon={<PiNavigationArrow />} />
          </Button>
        )
      ) : (
        <Button isClear onlyIcon variant={BUTTON_VARIANT.remove} onClick={onRemove}>
          <Button.Icon icon={<PiTrash />} />
        </Button>
      )}
    </div>
  );
};

export default ExternalIdCard;
